// pages/FormViewerPage/hooks/useFormViewer/actionsValidate.ts — Field validation callback
import { useCallback } from 'react';
import { validateCustomerFields } from '../../services/formViewerService';
import { validateVariantFields } from '../../services/formViewerService/variantValidation';
import type { FormViewerState } from './state';

export function useFormViewerValidate(s: FormViewerState, displayOptions: Array<{ name: string; values: string[] }>, isSimpleEmbed: boolean = false) {
    const { form, customerData, addressData, herbalClaimMode, selectedOptions } = s;

    const validateFields = useCallback(() => {
        const errs = validateCustomerFields(form, customerData, addressData, isSimpleEmbed, herbalClaimMode);
        // Varian wajib dipilih eksplisit — kecuali mode tanpa UI varian (simple-embed
        // lead-only / konsultasi: dropdown tidak ditampilkan, jangan tagih).
        const isConsult = !!form?.thankYouPage?.consultationMode;
        if (!isSimpleEmbed && !isConsult) Object.assign(errs, validateVariantFields(displayOptions, selectedOptions));
        return errs;
    }, [form, customerData, addressData, isSimpleEmbed, herbalClaimMode, displayOptions, selectedOptions]);

    return { validateFields };
}
